import { useEffect, useState } from 'react';
import getConfig from 'next/config';
import Request from '@apester/requests';
import { getUserFromRedirectUrl } from '../utils/browser-utils';
import { useStateValue, setPublisher, setLoading } from '../state/stateProvider';
import useUser from './use-user';
import { identifyTrackingUser } from '../utils/event-helper';

const { publicRuntimeConfig: { config } } = getConfig();

const usePublisher = () => {
  const [{ publisher }, dispatch] = useStateValue();
  const { user } = useUser();
  const [canFetch, setCanFetch] = useState(true);

  const applyPublisher = (publisherObject) => {
    setPublisher(dispatch, publisherObject);
    setLoading(dispatch, false);
  };

  const getAllowedEngineByChannels = async (channelId) => {
    const params = { channelId: channelId };

    const allowedEngine = await fetch(`${config.AUTH_URL}/channels/use-engines`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    });
    const allowedEngineObj = await allowedEngine.json();
    return allowedEngineObj.payload?.allowedEngines;
  };

  useEffect(() => {
    try {
      if (publisher?.engines?.length <= 0 && canFetch) {
        setCanFetch(false);
        const allowedEngines = getAllowedEngineByChannels(publisher.selectedPublisherId);
        allowedEngines.then(result => {
          const publisherObject = {
            selectedPublisherId: publisher.selectedPublisherId,
            engines: result,
          };
          applyPublisher(publisherObject);
          setCanFetch(true);
          return;
        });
      }
    } catch (e) {
      console.log(e);
      setPublisher(dispatch, 'error');
      setLoading(dispatch, false);
    }



  }, [publisher, dispatch]);

  return { publisher };
};

export default usePublisher;
